var legend = '_1693qtz0 _14wijgra';

export { legend };
//# sourceMappingURL=legend.css.js.map
